(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'public',
            url: '/?page&sort&search&tipo&organo&materia',
            data: {
                authorities: [],
                pageTitle: 'sgnmrApp.materia.home.title'
            },
            views: {
                'content@public': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fechaEmision,desc',
                    squash: true
                },
                search: null,
                tipo: null,
                organo: null,
                materia: null,
                emistart: null,
                emiend: null,
                pubstart: null,
                pubend: null,
                abrogado: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //http://localhost:8080/public/api/search?cacheBuster=1496249646638&page=0&size=20&sort=fechaEmision,desc&sort=id

                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        tipo: $stateParams.tipo,
                        organo: $stateParams.organo,
                        materia: $stateParams.materia,
                        emistart: $stateParams.emistart,
                        emiend: $stateParams.emiend,
                        pubstart: $stateParams.pubstart,
                        pubend: $stateParams.pubend,
                        abrogado: $stateParams.abrogado
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                organHierarchy: ['OrganoHierarchy', function(OrganoHierarchy) {
                    return OrganoHierarchy.get().$promise;
                }]
            }
        })
        .state('home-materia', {
            parent: 'public',
            url: '/materia/{materia}?page&sort&search&tipo&organo',
            data: {
                authorities: [],
                pageTitle: 'sgnmrApp.materia.home.title'
            },
            views: {
                'content@public': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fechaEmision,desc',
                    squash: true
                },
                search: null,
                tipo: null,
                organo: null,
                materia: null,
                emistart: null,
                emiend: null,
                pubstart: null,
                pubend: null,
                abrogado: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //http://localhost:8080/public/api/search?cacheBuster=1496249646638&page=0&size=20&sort=fechaEmision,desc&sort=id

                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        tipo: $stateParams.tipo,
                        organo: $stateParams.organo,
                        materia: $stateParams.materia,
                        emistart: $stateParams.emistart,
                        emiend: $stateParams.emiend,
                        pubstart: $stateParams.pubstart,
                        pubend: $stateParams.pubend,
                        abrogado: $stateParams.abrogado
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                organHierarchy: ['OrganoHierarchy', function(OrganoHierarchy) {
                    return OrganoHierarchy.get().$promise;
                }]
            }
        })
        .state('materia-abrogado', {
            parent: 'public',
            url: '/materia/{materia}/abrogado?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'sgnmrApp.materia.home.title'
            },
            views: {
                'content@public': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fechaEmision,desc',
                    squash: true
                },
                search: null,
                materia: null,
                abrogado: true
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //http://localhost:8080/public/api/search?cacheBuster=1496249646638&page=0&size=20&sort=fechaEmision,desc&sort=id

                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        materia: $stateParams.materia,
                        abrogado: $stateParams.abrogado
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                organHierarchy: ['OrganoHierarchy', function(OrganoHierarchy) {
                    return OrganoHierarchy.get().$promise;
                }]
            }
        });

    }
})();
